import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Models } from '@ibexfusion/models';
import { ProfileService } from '@services/profiles/profile.service';
import { GroupService } from '@services/groups/group.service';
import { GroupHasRoleInOrganisationService } from '@services/groups/group-has-role-in-organisation.service';
import { GroupHasSecuredAppService } from '@services/groups/group-has-secured-app.service';
import { PackageInstalledAppsService } from '@services/packages/package-installed-apps.service';
import { PackageService } from '@services/packages/package.service';
import { GroupHasProfileService } from '@services/groups/group-has-profile.service';
import { PageAction } from '../../../components/page-actions/page-actions.component';
import { CredentialsService } from '@services/credentials/credentials.service';
import { MessengerService } from '@services/messenger/messenger.service';
import { OrganisationService } from '@services/organisations/organisation.service';
import { DialogService } from '@services/dialog/dialog.service';
import { TranslateService } from '@services/translate/translate.service';
import { FrontProfilesService } from '@services/front-profiles/front-profiles.service';

@Component({
    selector: 'app-user-admin-edit',
    templateUrl: './user-admin-edit.component.html',
    styleUrls: ['./user-admin-edit.component.scss'],
    providers: [
        ProfileService, GroupService, GroupHasRoleInOrganisationService, PackageInstalledAppsService, GroupHasSecuredAppService, PackageService, GroupHasProfileService,
        CredentialsService, OrganisationService, FrontProfilesService
    ],
    standalone: false
})

export class UserAdminEditComponent implements OnInit {
  @ViewChild('editForm') editFormComponent: any;
  pageActions: PageAction[];
  type;
  organisationId;
  itemId;
  group: Models.Group;
  profile: Models.Profile;
  contentAuthor = false;
  securedContentAdmin = false;
  securedContent = false;
  orderModule = false;
  ticketingModule = false;
  title: string;
  packages: Models.Package[];
  packageInstalledApps: Models.PackageInstalledApp[];
  systemMessages: any;
  hasChanged = false;

  constructor(
    private route: ActivatedRoute, private credentialService: CredentialsService, private ms: MessengerService, private profileService: ProfileService, private router: Router,
    private translate: TranslateService, private dialogService: DialogService, private frontProfileService: FrontProfilesService, private groupService: GroupService
  ) {
  }

  async ngOnInit() {
    this.organisationId = this.route.snapshot.params['id'] || this.ms.getOrganisation()?.OrganisationID;
    this.type = this.route.snapshot.params['type'];
    this.itemId = this.route.snapshot.params['itemId'];
    this.title = await this.getTitle(this.itemId);
    if (this.type === 'profiles' && this.itemId) {
      this.profile = await this.profileService.get(this.itemId);
    }
    this.systemMessages = this.translate.get('system');
    this.initPageActions();
  }

  async getTitle(itemId) {
    if (!itemId) {
      return this.translate.get('userAdmin.' + this.type.slice(0, -1) + '.new');
    } else {
      const service = { 'frontend-profiles': this.frontProfileService, 'profiles': this.profileService }[this.type] || this.groupService;
      const res = await service.get(this.itemId || itemId);
      return (res?.name || res?.firstName + ' ' + res?.lastName).replace(/^pref_[^_]+_/, '');
    }
  }

  async initPageActions() {
    this.pageActions = [new PageAction({
      icon: 'subdirectory_arrow_left', title: 'Back', translationString: 'general.back', callback: () => {
        this.abort()
      }
    }), new PageAction({
      icon: 'save', title: 'Save', translationString: 'general.save', callback: () => {
        if (this.editFormComponent?.save) {
          this.editFormComponent.save();
        }
      }
    })];
    if (this.profile?.ProfileID) {
      const credentials = await this.credentialService.get(this.profile.ProfileID);
      const activated = !!credentials?.length;
      if (activated) {
        this.pageActions.push(new PageAction({
          icon: 'mail_lock', title: 'Forgot Password', translationString: 'userAdmin.profile.sendForgotPassword',
          callback: () => { this.forgotPassword() }
        }));
      } else {
        this.pageActions.push(new PageAction({
          icon: 'send', title: 'Activate Profile', translationString: 'userAdmin.profile.sendActivation',
          callback: () => { this.activateAccount() }
        }));
      }
    }
  }

  async activateAccount() {
    const apiKey = 'lXvM6ebAR6|gm0GRcxp20p4zG9nvir2Fxqbv3d6fhRRGNRXo9b9w6eF/Ht+WafSPJRgeAwklPivvUxqleBXPAkgIn8+2z2EIw==';
    await this.ms.activateAccount(this.profile, apiKey);
    this.initPageActions();
  }

  async forgotPassword() {
    await this.ms.createResetCredentials(this.profile.email);
  }

  async abort() {
    if (!this.hasChanged || await this.dialogService.confirm(this.systemMessages['general']['pendingChanges'])) {
      this.router.navigate([this.router.url.split('/')[1], this.route.snapshot.params['packageId'] || this.organisationId]);
    }
  }
}
